import vhCheck from "vh-check";

const viewportHeight = vhCheck({
    cssVarName: "vh-offset",
    bind: false,
});
